import { api_base_url, request } from '../utils';

const BASE = (api_base_url || '').replace(/\/+$/, '');

export class ThematicAreaService {
  static ENDPOINT = `${BASE}/thematicArea`;

  static async getAll() {
    return await request({
      url: `${this.ENDPOINT}/`,
      auth: false
    })
  }
}

export default ThematicAreaService;
